import classNames from "classnames";
import Icon from "~/components/shared/Icon";
import * as React from "react";

type LimitingBannerProps = {
  children: React.ReactNode;
  colorScheme: "blue" | "orange";
};

export function LimitingBanner({ children, colorScheme }: LimitingBannerProps) {
  const colorClasses = {
    blue: {
      border: "border-blue-500",
      background: "bg-blue-100",
      icon: "text-blue-500",
    },
    orange: {
      border: "border-orange-500",
      background: "bg-orange-100",
      icon: "text-orange-500",
    },
  };

  const colors = colorClasses[colorScheme];

  return (
    <div className={classNames("flex overflow-hidden rounded border", colors.border)}>
      <div
        className={classNames(
          "flex w-8 shrink-0 justify-center border-r pt-4",
          colors.border,
          colors.background,
        )}
      >
        <Icon
          icon="heroicons/16/solid/exclamation-triangle"
          className={classNames("h-4 w-4", colors.icon)}
        />
      </div>

      <div className="grow px-4 py-3">{children}</div>
    </div>
  );
}
